import React from 'react'

import { Field } from 'formik'

import { Form } from '_zari/core'

const FlagTasaPorTarjetaFormGroup = ({ iValue, fIsSubmitting }) => {
  return (
    <Field name='flagTasaPorTarjeta'>
      {({ field }) => (
        <Form.Checkbox
          {...field}
          checked={iValue}
          disabled={fIsSubmitting}
          id='checkbox-flagTasaPorTarjeta'
          label='Tasa por tarjeta'
        />
      )}
    </Field>
  )
}

export default React.memo(FlagTasaPorTarjetaFormGroup)
